// ------------------------------------
// props 輸入需求 :
// props.data : object : { data: array }                ( {primary : main data, average : average : data} )
// props.chartName : str                                ( 表格名稱 )
// props.yAxis : object                                 ( y軸格式 )
// props.data_label : array                             ( ["x軸名稱", "y軸名稱"] )
// ------------------------------------
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts'
import React, { useEffect, useState } from 'react'
import '../../../../styles/_Chart_Hook_BasicLine.scss'
import { useTranslation } from 'react-i18next';
import { LogTime } from '../../../../actions/forFrontEnd_Log';

const LineChart4in1 = (props) => {
    function handleCharts() {
        switch (props.chartSwitch) {
            case 0:
                return <ChartSet1
                    SEdata={props.SEdata}
                    turnCount={props.turnCount}
                    NIBtimes={props.NIBtimes}
                    timeSelc={props.timeSelc} />
            case 1:
                return <ChartSet2
                    latency={props.latency}
                    totalSleepTime={props.totalSleepTime}
                    timeSelc={props.timeSelc} />
            case 2:
                return <ChartSet3
                    NIBdata={props.NIBdata}
                    NIBtimes={props.NIBtimes}
                    NIBMax={props.NIBMax}
                    timeSelc={props.timeSelc} />
            case 3:
                return <ChartSet4
                    startSleepTime={props.startSleepTime}
                    endSleepTime={props.endSleepTime}
                    timeSelc={props.timeSelc} />
            default:
                return <ChartSet1 SEdata={props.SEdata} turnCount={props.turnCount} NIBdata={props.NIBdata} timeSelc={props.timeSelc} />
        }
    }

    return (                                                       // desktop
        <div className='h-100'>
            <div className="fx-d-c fx-ccc h-100">
                <div className='fx-d-r w-100 h-100 mar-15 b'></div>
                {handleCharts()}
            </div>
        </div>
    )
}
export default LineChart4in1;

function ChartSet1(props) {
    const { t } = useTranslation()
    const [chartSet, setChartSet] = useState({
        chart: { type: "line" },
        series: []
    });
    let _class = { className: "w-100 h-100 chart-frame" }
    useEffect(() => {
        let _SEdata = props.SEdata
        let _TC = props.turnCount
        let _NIBtimes = props.NIBtimes
        // SE
        let series1 = [{
            data: _SEdata?.primary,
            name: t("HISTORY_RECORD.SLEEP_EFFIFIENCY"),
            type: "line",
            yAxis: 0,
            zindex: 0,
            color: "#009DAE"
        },
        {
            data: _SEdata?.secondary,
            yAxis: 0,
            zindex: 1,
            type: "line",
            name: t("HISTORY_RECORD.SLEEP_AVG_EFFIFIENCY"),
            color: "#009DAE70",
            marker: { enabled: false }
        }]

        // NIB data
        let series2 = [{
            data: _TC?.primary,
            type: "line",
            yAxis: 1,
            name: t("HISTORY_RECORD.SLEEP_NIGHT_TRUN"),
            color: "#880000",
            dashStyle: 'shortdot',
            marker: { enabled: false }
        },
        {
            data: _TC?.secondary,
            type: "line",
            yAxis: 1,
            name: t("HISTORY_RECORD.SLEEP_AVG_NIGHT_TRUN"),
            color: "#88000070",
            dashStyle: 'shortdot',
            marker: { enabled: false }
        }]

        let series3 = [{
            data: _NIBtimes?.primary,
            type: "spline",
            yAxis: 1,
            name: t("HISTORY_RECORD.SLEEP_NIGHT_NOTINBED"),
            color: "#a40000",
            dashStyle: 'shortdot',
            marker: { enabled: false }
        },
        {
            data: _NIBtimes?.secondary,
            type: "spline",
            yAxis: 1,
            name: t("HISTORY_RECORD.SLEEP_AVG_NIGHT_NOTINBED"),
            color: "#a4000070",
            dashStyle: 'shortdot',
            marker: { enabled: false }
        }]
        setChartSet({
            chart: { zoomType: 'xy', backgroundColor: "rgb(255, 253, 232)" },
            title: { text: "" },
            xAxis: {
                min: new Date((props.timeSelc - 14 * 24 * 60 * 60 * 1000)).getTime(),
                max: new Date(props.timeSelc).getTime(),
                type: 'datetime',
                crosshair: true
            },
            yAxis: [{
                background: '#000000',
                title: { text: "" },
                endOnTick: false,
                max: 100,
                min: 0,
                startOnTick: false,
                endOnTick: false,
                labels: { format: '{value}%' }
            }, {
                title: { text: "" },
                labels: { format: `{value} ${t("GLOBAL.TIMES")}` },
                opposite: true
            }
            ],
            exporting: { enabled: false },
            plotOptions: { series: { animation: false, pointWidth: 15 }, },
            tooltip: { shared: true },
            series: [...series2, ...series1, ...series3]
        })
    }, [props.SEdata, props.turnCount, props.NIBtimes])
    return <div className="chart-box fx-d-r">
        <HighchartsReact
            highcharts={Highcharts}
            options={chartSet}
            allowChartUpdate={true}
            containerProps={{ className: "w-100 h-100" }} />
    </div>
}

function ChartSet2(props) {
    const { t } = useTranslation()
    const [chartSet, setChartSet] = useState({
        chart: { type: "line" },
        series: []
    });
    let _class = { className: "w-100 h-100 chart-frame" }
    useEffect(() => {
        let _Latencydata = props.latency
        let _TotalSleeptimes = props.totalSleepTime
        // NIB data
        let series2 = [{
            data: _Latencydata.primary,
            name: t("HISTORY_RECORD.SLEEP_LATENCY"),
            color: "#e3c500",
            marker: { enabled: false }
        }
        ]
        // NIB max
        let series1 = [{
            data: _TotalSleeptimes.primary,
            name: t("HISTORY_RECORD.TOTAL_SLEEPING_TIME"),
            color: "rgb(44, 158, 240)",
            marker: { enabled: false }
        }
        ]
        setChartSet({
            chart: { type: 'column', backgroundColor: "rgb(255, 253, 232)" },
            title: { text: "" },
            xAxis: {
                min: new Date((props.timeSelc - 14 * 24 * 60 * 60 * 1000)).getTime(),
                max: new Date(props.timeSelc).getTime(),
                type: 'datetime',
                crosshair: true
            },
            yAxis: {
                title: { text: "" },
                max: 43200,
                min: 0,
                tickInterval: 14400,
                startOnTick: false,
                endOnTick: false,
                labels: {
                    formatter: function () {
                        return `${parseInt(this.value / 3600)}${t("GLOBAL.UNIT.HOURS")} ${parseInt((this.value % 3600) / 60)}${t("GLOBAL.UNIT.MINUTE")}`;
                    }
                },
            },
            exporting: { enabled: false },
            plotOptions: {
                series: { animation: false },
                area: {
                    stacking: 'normal',
                    lineColor: '#666666',
                    lineWidth: 1,
                    marker: {
                        lineWidth: 1,
                        lineColor: '#666666'
                    }
                }
            },
            tooltip: {
                shared: true,
                enabled: true,
                formatter: function () {
                    let head = new LogTime(new Date(this.x - 28800000)).getDay();
                    var tooltip = '<div class="chartTooltip"><div>'
                        + head + '</div><br /><div>'
                        + this.points[0].series.name + " : " + `${addZero(parseInt(this.points[0].y / 3600))}:${addZero(parseInt((this.points[0].y % 3600) / 60))}`
                        + '</div><br /><div>'
                        + this.points[1].series.name + " : " + `${addZero(parseInt(this.points[1].y / 3600))}:${addZero(parseInt((this.points[1].y % 3600) / 60))}`
                        + '</div><br /><div>'
                        + t("HISTORY_RECORD.TOTAL_INBED_TIME") + `${addZero(parseInt((this.points[1].y + this.points[0].y) / 3600))}:${addZero(parseInt(((this.points[1].y + this.points[0].y) % 3600) / 60))}`
                        + '</div></div>';
                    return tooltip
                }
            },
            series: [...series2, ...series1]
        })
        function addZero(time) { return (time / 10 >= 1) ? time : "0" + time }

    }, [props])
    return <div className="chart-box fx-d-r">
        <HighchartsReact
            highcharts={Highcharts}
            options={chartSet}
            allowChartUpdate={true}
            containerProps={{ className: "w-100 h-100" }} />
    </div>
}

function ChartSet3(props) {
    const { t } = useTranslation()
    const [chartSet, setChartSet] = useState({
        chart: { type: "line" },
        series: []
    });
    let _class = { className: "w-100 h-100 chart-frame" }

    useEffect(() => {
        let _NIBdata = props.NIBdata
        let _NIBtimes = props.NIBtimes
        let _NIBMax = props.NIBMax
        // NIB data
        let series2 = [{
            data: _NIBtimes.primary,
            type: "spline",
            yAxis: 1,
            name: t("HISTORY_RECORD.SLEEP_NIGHT_NOTINBED"),
            color: "#a40000",
            dashStyle: 'shortdot',
            marker: { enabled: false }
        },
        {
            data: _NIBtimes.secondary,
            type: "spline",
            yAxis: 1,
            name: t("HISTORY_RECORD.SLEEP_AVG_NIGHT_NOTINBED"),
            color: "#a4000070",
            dashStyle: 'shortdot',
            marker: { enabled: false }
        }]
        // NIB max
        let series3 = [{
            data: _NIBMax.primary,
            yAxis: 0,
            type: "line",
            name: t("HISTORY_RECORD.SLEEP_MAX_NIGHT_NOTINBED"),
            color: "#cf8e00",
            marker: { enabled: false }
        },
        {
            yAxis: 0,
            data: _NIBMax.secondary,
            type: "line",
            name: t("HISTORY_RECORD.SLEEP_AVG_MAX_NIGHT_NOTINBED"),
            color: "#cf8e0070",
            marker: { enabled: false }
        }]
        // NIB times
        let series1 = [{
            data: _NIBdata.primary,
            yAxis: 0,
            type: "column",
            name: t("HISTORY_RECORD.SLEEP_NIGHT_NOTINBED_TIME"),
            color: "#00ae09",
            marker: { enabled: false }
        },
        {
            data: _NIBdata.secondary,
            yAxis: 0,
            type: "column",
            name: t("HISTORY_RECORD.SLEEP_AVG_NIGHT_NOTINBED_TIME"),
            color: "#00ae0970",
            marker: { enabled: false }
        }]

        setChartSet({
            chart: { zoomType: 'xy', backgroundColor: "rgb(255, 253, 232)" },
            title: { text: "" },
            xAxis: {
                min: new Date((props.timeSelc - 14 * 24 * 60 * 60 * 1000)).getTime(),
                max: new Date(props.timeSelc).getTime(),
                type: 'datetime',
                crosshair: true
            },
            yAxis: [{
                title: { text: "" },
                labels: {
                    formatter: function () {
                        return `${parseInt(this.value / 3600)}${t("GLOBAL.UNIT.HOURS")} ${parseInt((this.value % 3600) / 60)}${t("GLOBAL.UNIT.MINUTE")}`;
                    }
                },
            },
            {
                title: { text: "" },
                labels: { format: `{value} ${t("GLOBAL.TIMES")}` },
                opposite: true
            }],
            exporting: { enabled: false },
            plotOptions: { series: { animation: false }, },
            tooltip: { enabled: true, shared: true },
            series: [...series1, ...series2, ...series3]
        })

    }, [props])
    return <div className="chart-box fx-d-r">
        <HighchartsReact
            highcharts={Highcharts}
            options={chartSet}
            allowChartUpdate={true}
            containerProps={{ className: "w-100 h-100" }} />
    </div>
}

function ChartSet4(props) {
    const { t } = useTranslation()
    const [chartSet, setChartSet] = useState({
        chart: { type: "line" },
        series: []
    });
    let _class = { className: "w-100 h-100 chart-frame" }

    useEffect(() => {
        let _start = props.startSleepTime
        let _end = props.endSleepTime
        // NIB data
        let series2 = [{
            data: _start.primary,
            type: "spline",
            name: t("HISTORY_RECORD.INBED"),
            color: "#a40000",
            dashStyle: 'shortdot',
            marker: { enabled: true }
        }
        ]
        // NIB times
        let series1 = [{
            data: _end.primary,
            type: "spline",
            name: t("HISTORY_RECORD.WAKEUP_TIME"),
            color: "#00ae09",
            marker: { enabled: true }
        }
        ]

        setChartSet({
            chart: { zoomType: 'xy', backgroundColor: "rgb(255, 253, 232)" },
            title: { text: "" },
            xAxis: {
                min: new Date((props.timeSelc - 14 * 24 * 60 * 60 * 1000)).getTime(),
                max: new Date(props.timeSelc).getTime(),
                type: 'datetime',
                crosshair: true
            },
            yAxis: {
                max: 86400,
                min: 0,
                startOnTick: false,
                endOnTick: false,
                tickInterval: 28800,
                title: { text: "" },
                labels: {
                    formatter: function () {
                        return `${parseInt(this.value / 3600)}${t("GLOBAL.UNIT.HOURS")} ${parseInt((this.value % 3600) / 60)}${t("GLOBAL.UNIT.MINUTE")}`;
                    }
                },
            },
            exporting: { enabled: false },
            plotOptions: { series: { animation: false }, },
            tooltip: {
                backgroundColor: "white",
                // borderColor:"#00ae09",
                // shadow:false,
                // borderWidth:3,
                // crosshairs: true,
                shared: true,
                enabled: true,
                valueSuffix: ` ${t("HISTORY_RECORD.TIMES_MIN")}`,
                formatter: function () {
                    let head = new LogTime(new Date(this.x - 28800000)).getDay();
                    var tooltip = '<div><div>'
                        + head + '</div><br /><div>'
                        + this.points[1].series.name + " : " + `${addZero(parseInt(this.points[1].y / 3600))}:${addZero(parseInt((this.points[1].y % 3600) / 60))}`
                        + '</div><br /><div>'
                        + this.points[0].series.name + " : " + `${addZero(parseInt(this.points[0].y / 3600))}:${addZero(parseInt((this.points[0].y % 3600) / 60))}`
                        + '</div></div>';
                    return tooltip
                }
            },
            series: [...series1, ...series2]
        })
        function addZero(time) { return (time / 10 >= 1) ? time : "0" + time }
    }, [props])
    return <div className="chart-box fx-d-r">
        <HighchartsReact
            highcharts={Highcharts}
            options={chartSet}
            allowChartUpdate={true}
            containerProps={{ className: "w-100 h-100" }} />
    </div>
}